<div class="header__container">
  <div class="logo_user">
    <div class="logo-placeholder"></div>
    <div class="logo-right">
      <nav class="main-menu__nav" #headerMenu>
        <ul class="inline-list">
            <li *ngIf="aboutUs"><a mat-button disableRipple href="{{aboutUs}}" target="_blank">About us</a></li>
            <li *ngIf="contactUs"><a mat-button disableRipple href="{{contactUs}}" target="_blank">Contact</a></li>
            <li *ngIf="createNewAccountLink"><a mat-button disableRipple href={{createNewAccountLink}} target="_blank">{{createNewAccountLinkText}}</a></li>
        </ul>
      </nav>
    </div>
  </div>
</div>

<div class="header__container--small">
  <div class="logo_user">
    <div class="logo-right">
      <div class="menu-popup--mobile">
        <a [matMenuTriggerFor]="accountMenu">
          <i class="material-icons material-icons--large">menu</i>
        </a>
        <mat-menu #accountMenu="matMenu" yPosition="below" [overlapTrigger]="false">
            <a class="profile-menu-button" mat-menu-item disableRipple *ngIf="aboutUs" href="{{aboutUs}}" target="_blank">About us</a>
            <a class="profile-menu-button" mat-menu-item disableRipple *ngIf="contactUs" href="{{contactUs}}" target="_blank">Contact</a>
            <a class="profile-menu-button" mat-menu-item disableRipple *ngIf="createNewAccountLink" href={{createNewAccountLink}} target="_blank">{{createNewAccountLinkText}}</a>
        </mat-menu>
      </div>
    </div>
    <div class="logo-placeholder"></div>
  </div>
</div>